import React from 'react';
import { ThemeProvider } from 'styled-components';
import GlobalStyles from './styles/GlobalStyles';
import theme from './styles/theme';
import { AnniversaryProvider } from './context/AnniversaryContext';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import FloatingHearts from './components/shared/FloatingHearts';

// Pages
import Home from './pages/Home';
import Photobook from './pages/Photobook';
import Story from './pages/Story';
import Playlist from './pages/Playlist';
import Photocards from './pages/Photocards';
import OurMemories from './pages/OurMemories';
import ForZaria from './pages/ForZaria';
import Valentines2026 from './pages/Valentines2026';

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <AnniversaryProvider>
        <Router>
          <FloatingHearts />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/photobook" element={<Photobook />} />
            <Route path="/story" element={<Story />} />
            <Route path="/playlist" element={<Playlist />} />
            <Route path="/photocards" element={<Photocards />} />
            <Route path="/our-memories" element={<OurMemories />} />
            <Route path="/for-zaria" element={<ForZaria />} />
            <Route path="/valentines-2026" element={<Valentines2026 />} />
          </Routes>
        </Router>
      </AnniversaryProvider>
    </ThemeProvider>
  );
};

export default App;
